// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1111":"636c2175e8c24638","5203":"85d48c6e2c678069"}[chunkId] + ".css";
};